import { TOTAL_CLIENTS } from '@propertypal/shared/src/constants/products';
import WhyFolowers from '@propertypal/shared/src/resources/icons/products/why-followers-icon.svg';
import WhyLeading from '@propertypal/shared/src/resources/icons/products/why-leading-portal-icon.svg';
import WhyLeads from '@propertypal/shared/src/resources/icons/products/why-leads-icon.svg';
import WhyVisitors from '@propertypal/shared/src/resources/icons/products/why-visitors-icon.svg';
import WhyWebsite from '@propertypal/shared/src/resources/icons/products/why-website-icon.svg';
import WhySessions from '@propertypal/shared/src/resources/icons/products/why-website-sessions-icon.svg';
import PPLogoImg from '@propertypal/shared/src/resources/logos/PropertyPalLogo.svg?url';
import React from 'react';
import { useTheme, DefaultTheme } from 'styled-components';
import { Heading, Text, TextProps } from '../typography';
import { Logo, ProductsContent } from './ProductsContent.style';
import { ProductsGrid, WhyProductsGridItem } from './ProductsGrid.style';
import { WhyHeading, WhySubHeading, WhyText } from './WhyPropertyPalContent.style';

type Icon = {
  SVG: string;
  heading?: string;
  text: string;
  reverse?: boolean;
  maxW?: number;
  headingWeight?: TextProps['fontWeight'];
  headingColor?: Exclude<keyof DefaultTheme, 'prime'>;
  gap?: number;
};

const icons: Icon[] = [
  {
    SVG: WhyVisitors,
    heading: '1.3 million',
    text: 'active users monthly on PropertyPal',
    maxW: 220,
  },
  {
    SVG: WhySessions,
    heading: '5.75 million',
    text: 'website sessions every month',
    maxW: 180,
  },
  {
    SVG: WhyLeading,
    heading: '155 million',
    text: 'page views monthly',
    maxW: 120,
  },
  {
    SVG: WhyFolowers,
    heading: '300,000+',
    text: 'property followers across Facebook and Instagram',
    maxW: 270,
  },
  {
    SVG: WhyLeads,
    heading: '1.96 million',
    text: 'leads delivered last year',
    maxW: 160,
  },
  {
    SVG: WhyWebsite,
    heading: `${TOTAL_CLIENTS}+`,
    text: 'estate agent and developer websites',
    maxW: 200,
  },
];

const WhyPropertyPalContent = () => {
  const theme = useTheme();
  return (
    <ProductsContent>
      <Logo src={PPLogoImg.src} alt="PropertyPal Logo" />
      <WhyHeading align="center" mb={10} fontSize={36} why>
        Why PropertyPal?
      </WhyHeading>
      <WhySubHeading align="center" mb={50} fontSize={22} fontWeight="normal" why>
        One of the country&apos;s most recognised brands
      </WhySubHeading>
      <WhyText align="center" fontSize={20} mb={120} maxWidth={950} autoMargin>
        We aim to maximise the visibility of your listings and connect you with potential buyers when they&apos;re most
        engaged with property. With a variety of advertising options tailored to suit your needs, we ensure your
        listings stand out from the crowd, reaching your ideal audience at the perfect moment. Partnering with us opens
        doors to impactful opportunities you might not have considered before.
      </WhyText>
      <ProductsGrid rowGap={100}>
        {icons.map(({ SVG, heading, text, reverse, maxW, headingWeight, headingColor, gap }) => (
          <WhyProductsGridItem key={heading || text} reverse={reverse} maxW={maxW} gap={gap}>
            <SVG />
            <div>
              {heading && (
                <Heading fontWeight={headingWeight} color={headingColor ? theme[headingColor] : undefined}>
                  {heading}
                </Heading>
              )}
              <Text>{text}</Text>
            </div>
          </WhyProductsGridItem>
        ))}
      </ProductsGrid>
    </ProductsContent>
  );
};

export default WhyPropertyPalContent;
